import { render, staticRenderFns } from "./DiscountFormModal.vue?vue&type=template&id=384241f6&"
import script from "./DiscountFormModal.vue?vue&type=script&lang=js&"
export * from "./DiscountFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports